import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'
import JelledMobileModal from 'components/JelledModal/JelledMobileModal'

const TwinOverviewModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <JelledMobileModal isOpen={true} onClose={onClose} isCloseButtonEnabled={true}>
      <Stack spacing={2}>
        <Typography
          variant="h4"
          sx={{
            color: COLORS.PURE_WHITE,
          }}>
          What is a digital twin?
        </Typography>

        <Typography
          variant="pS"
          sx={{
            color: COLORS.PURE_WHITE,
          }}>
          A twin is a digital representation of your knowledge and is comprised of advanced deep learning models.
        </Typography>

        <Typography
          variant="pS"
          sx={{
            color: COLORS.PURE_WHITE,
          }}>
          After connecting your twin to your data sources, it can assist you by auto-generating insights and responses.
        </Typography>

        <Typography
          variant="pS"
          sx={{
            color: COLORS.PURE_WHITE,
          }}>
          Other users can also chat directly with your twin to get responses in real-time.
        </Typography>
      </Stack>
    </JelledMobileModal>
  )
}

export default TwinOverviewModal
